import Login from '@/src/views/Login';

export default function LoginPage() {
  return (
    <Login />
  )
}